<template>
  <div class="chart-wrapper"
       :style="style">
    <slot />
  </div>
</template>

<script>
    export default {
        props: {
            dataPadding: {
                type: String,
            },
        },

        computed: {
            style() {
                return {
                    padding: this.dataPadding,
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
@import "~@variables";

.chart-wrapper {
  position: relative;
  padding: 30px;
  border: 1px solid $grey-3;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  //   min-height: 200px;
  //   justify-content: center;
}
</style>
